<script>
import {ref} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import {useRoute} from "vue-router";
import {useStore} from "vuex";
import router from "@/router";

export default {
  name: "W_ServicesPerformed",
  components: {LoadingPage},
  setup(){

    let store = useStore()

    let loading = ref(false)
    let customer_id =ref(useRoute().params.service_id)

    let my_service = ref([])
    let user_name = ref()
    let car_name = ref()

    function get_customer() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'show'}, 'worker/customers', true).then((res) => {
        user_name.value = res.data[0].name
        car_name.value = res.data[0].car
        my_service.value = res.data.find(item => item.id === +customer_id.value)?.service;
        loading.value = false
      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_customer)
      })
    }
    get_customer()


    function chang_service(type, id) {
      switch (type) {
        case 'new':
          store.commit('set_name_new_service' , user_name.value)
          router.push({name:'W_SignUpService' , params:{action:'add_worker', service_id:0, customer_id:customer_id.value}})
          break

        case 'details':
          my_service.value.forEach((item) => {
            if (item.id === id) {
              store.commit('set_name_new_service', user_name.value)
              router.push({name:'W_SignUpService' , params:{action:'show_detail', service_id:item.id, customer_id:customer_id.value}})
              return false
            }
          })
          break

        case 'edit':
          my_service.value.forEach((item) => {
            if(item.id === id) {
              store.commit('set_name_new_service', user_name.value)
              router.push({name:'W_SignUpService' , params:{action:'edit_worker', service_id:item.id, customer_id:customer_id.value}})
              return false
            }
          })
          break
      }
    }


    return{
      loading,
      my_service,
      user_name,
      car_name,
      customer_id,
      chang_service,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':''" class="bg-color-liner">
    <div style="height: 5rem" class="d-flex align-items-center p-4">
      <img onclick="window.history.back()" class="icon-size-1 rounded-pill ms-3" src="../assets/img/icon-back.svg" alt="">
      <p class="text-white font-bold font-4">سرویس های انجام شده</p>
    </div>


    <div id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">

      <div v-if="my_service.length === 0"
           class="animate__animated animate__fadeIn w-100 h-75 d-flex justify-content-center">
        <div class="d-flex flex-column justify-content-center align-items-center">
          <img style="width: 10rem" src="../assets/img/icon-recruitment.svg" alt="" class="mb-4">
          <p class="font-4 text-center">در حال حاضر آیتمی وجود ندارد...!</p>
        </div>
      </div>


      <div v-else v-for="item in my_service" :key="item.id" class="animate__animated animate__fadeIn shadow-KhA d-flex justify-content-between p-3 mt-1 rounded-5 mt-3">
        <div>
          <p class="font-5 font-bold text-color ">{{ car_name }}</p>
          <p class="font-5 font-bold text-color mt-3"> تاریخ سرویس  <span> {{ item.service_date_persian }} </span></p>
          <p class="font-5 font-bold text-color mt-3">{{ user_name }}</p>
        </div>
        <div class="d-flex flex-column">
          <p @click="chang_service('edit' , item.id)" class="bg-yellow text-decoration-none text-color_white px-4 py-2 rounded-5 font-5 font-bold">ویرایش</p>
          <p @click="chang_service('details' , item.id)" class="bg-color-light text-decoration-none px-4 py-2 rounded-5 mt-3 font-5 font-bold">جزئیات</p>
        </div>
      </div>



      <div @click="chang_service('new')" id="add_icon" class="animate__animated animate__fadeInUpBig position-fixed d-flex align-items-center flex-column text-decoration-none max_width bottom-5">
        <img class="icon-size-7 icon_shadow mb-2" src="../assets/img/icon-add.svg" alt="">
        <p class="font-5 text-decoration-none text-color text-center font-bold">ثبت سرویس جدید</p>
      </div>

    </div>
  </div>

</template>

<style scoped>
.shadow-KhA {
  box-shadow: 0px 8px 18px rgba(189, 215, 234, 0.6);
}
</style>